module.exports = __webpack_public_path__ + "img/19.6129e87d.png";